import React, {FC, ReactElement, useEffect} from 'react';
import type {tabsProps} from './Tabs';

type TabsEditorProps = {
    activeTab:number,
    setInstance:Function,
    changeActiveTab:Function,
    comboInstance:Function,
}

type TabsProps = tabsProps & TabsEditorProps;


const Tabs: FC<TabsProps> = ({...props}): ReactElement => {

    const useAppDispatch = props.editorPlugins.useAppDispatch;
    const dispatch = useAppDispatch();
    const changeValue = props.editorPlugins.changeValue;

    useEffect(() => {
        checkForActiveTab();
    }, [props.settings.tabsItems]);

    function checkForActiveTab() {
        const activeTabIndex = props.settings.tabsItems.titles.findIndex((title:any) => title.activeTab);
        if(activeTabIndex !== -1) {
            props.changeActiveTab(activeTabIndex);
            let titles = props.settings.tabsItems.titles.map((title: any) => {
                let newTitle = {...title};
                newTitle.activeTab = false;
                return newTitle;
            })
            let newTabsItem = {
                ...props.settings.tabsItems,
                titles: titles
            }
            let changeValueData = {
                path: props.path,
                data: {
                    name: 'tabsItems',
                    content: newTabsItem
                },
                object: 'combo'
            };
            dispatch(changeValue(changeValueData));
        }
    }

    return props.comboInstance();

};
export default Tabs;
